@import 'src/global/variables';
@import 'src/global/mixins';
@import '../../global/accessibility.css';

.nj-home {
  padding: 10px;
}

